import { LuIcon } from "@overmap-ai/blocks"
import { use } from "react"

import { DayPickerPopover } from "../../../components/Popovers/DayPickerPopover"
import { modelIconMapping } from "../../../mappings/icons"
import { formatCompactDate, formatDateRange } from "../../../utils/date"
import { FilterModifierDropdown, RemoveFilterButton } from "../../components"
import { FilterCellBadge } from "../../components/FilterCellBadge"
import { FilterCellButton } from "../../components/FilterCellButton"
import { FilterCellRoot } from "../../components/FilterCellRoot"
import { FilterRendererContext } from "../../contexts/FilterRendererContext/context"
import type { FilterDefRenderProps } from "../BaseFilterDef"
import type { SubmittedAtFilterDef } from "./SubmittedAtFilterDef"

type SubmittedAtFilterCellProps = FilterDefRenderProps<SubmittedAtFilterDef>

export const SubmittedAtFilterCell = (props: SubmittedAtFilterCellProps) => {
	const { filterDef, filter, filterManager } = props

	const { size } = use(FilterRendererContext)

	const filterValue = filter.getFilterValue()
	const filterModifier = filter.getFilterModifier()

	const getFilterValueUi = () => {
		switch (filterModifier) {
			case "equals":
			case "notEquals":
			case "before":
			case "after": {
				const afterModifier = filterDef.modifiers.after
				const afterFilterValue =
					filterValue && afterModifier.isFilterValueValid(filterValue) ? filterValue : undefined

				return (
					<DayPickerPopover
						size={size}
						required
						mode="single"
						selected={afterFilterValue}
						onSelect={filter.setFilterValue}
					>
						<FilterCellButton className="truncate">
							{afterFilterValue ? formatCompactDate(afterFilterValue) : "..."}
						</FilterCellButton>
					</DayPickerPopover>
				)
			}
			case "in":
			case "notIn": {
				const inModifier = filterDef.modifiers.in
				const inFilterValue =
					filterValue && inModifier.isFilterValueValid(filterValue) ? filterValue : undefined

				return (
					<DayPickerPopover
						size={size}
						required
						mode="range"
						selected={inFilterValue}
						onSelect={filter.setFilterValue}
					>
						<FilterCellButton className="truncate">
							{inFilterValue ? formatDateRange(inFilterValue) : "..."}
						</FilterCellButton>
					</DayPickerPopover>
				)
			}
		}
	}

	return (
		<FilterCellRoot>
			<FilterCellBadge>
				<LuIcon icon={modelIconMapping.dueDate} />
				Submitted at
			</FilterCellBadge>

			<FilterModifierDropdown filterDef={filterDef} filter={filter}>
				<FilterCellButton>
					{filterDef.getFilterModifier(filterModifier).modifier.render(filterValue)}
				</FilterCellButton>
			</FilterModifierDropdown>

			{getFilterValueUi()}

			<RemoveFilterButton filter={filter} filterManager={filterManager} />
		</FilterCellRoot>
	)
}
